<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑会员</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="memberlist.length > 1 ? memberlist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回会员管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsMembers'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in memberlist" :key="index">
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <wcupload :option="{size:'large'}" 
                        :value="item.thumb" 
                        @finish="(val)=> {
                            item.thumb=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">会员名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入会员名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.name=val.value;
                            }
                            if(val.type=='change') {
                                item.name=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">手机号码<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入手机号码名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.phone"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.phone=val.value;
                            }
                            if(val.type=='change') {
                                item.phone=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">电话（座机）</label>
                    <wcinput :option="{placeholder:'请输入座机号码',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.telephone"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.telephone=val.value;
                            }
                            if(val.type=='change') {
                                item.telephone=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">会员类型</label>
                    <wcselect :option="{placeholder:'请选择会员类型',filterable:true,ischange:true,width:'250px'}" 
                        :value="item.iscompanyvalue" 
                        :list="membertypelist"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.iscompanyvalue=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">会员标识</label>
                    <wcselect :option="{placeholder:'请选择会员标识',filterable:true,ischange:true,width:'250px'}" 
                        :value="item.is_robot" 
                        :list="membersyslist"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.is_robot=val.value;
                            }
                        }"
                    />
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
export default {
    components:{},
    data() {
        return {
            Browser:'editmember',
            loadingobj:'editmember',
            limit:10,  //限制添加数据条数
            memberinfo:{id:'',name:'',phone:'',telephone:'',thumb:'',iscompany:1,is_robot:1,note:''}, //会员模板信息           
            memberlist:[], //会员信息列表
            membertypelist:[], //会员类型列表
            membersyslist:[],  //会员系统类型标识
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetMemberTypeList(isfresh); //获取会员类型信息
            this.GetMemberSysList(isfresh);  //获取会员系统标识信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetMemberInfo(data.param.ids);
                }).catch(()=> {

                });

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetMemberInfo(data.param.ids);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.memberlist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个品牌',type:'warning'});return false;}
            var data=[];
            for(var i in this.memberlist) data.push(this.memberlist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.EDIT_MEMBER({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$parent.JUMPVIEW({name:'EsMembers',delname:'EsEditMember'})
                this.$notice({title:'成功提示',message:'编辑数据成功',type:'success'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取会员信息详情 **/
        GetMemberInfo(ids) {
            INTERFACE_MODEL_MEMBER.GET_MEMBER_INFO({id:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.memberlist=res.data;
            });
        },


        /** 获取会员类型信息 **/
        GetMemberTypeList(isfresh) {
            this.$method.GET_MEMBER_TYPES(isfresh).then((res) => {this.membertypelist=res;console.log(res)});
        },


        /** 获取会员系统信息标识 **/
        GetMemberSysList(isfresh) {
            this.$method.GET_MEMBER_SYS_TYPE(isfresh).then((res) => {this.membersyslist=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>